<!--
@create date 2023-10-31
@desc m08f.phomemo.com
-->
<template>
  <div class="m08f-guide2-div">
    <div class="scroll-items-div">
      <ul>
        <li
          :class="
            clickName === 'howToVideosRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('howToVideosRef')"
        >
          HOW-TO VIDEOS
        </li>
        <li
          :class="
            clickName === 'driversRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('driversRef')"
        >
          DRIVERS
        </li>
        <li
          :class="
            clickName === 'appDownloadRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('appDownloadRef')"
        >
          APP
        </li>
        <li
          :class="
            clickName === 'faqRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('faqRef')"
        >
          FAQ
        </li>
      </ul>
    </div>
    <div class="topContainerDivEx tp81TopContainer">
      <h1>TP81 Tattoo Stencil Printer Support</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/TP81.jpg"
            style="margin: 10px auto; width: 200px"
          />
        </div>
        <div class="rightDiv">
          <p>
            In addition to the printer support and repair resources on this
            page, also see the following:
          </p>
          <div class="linkDiv">
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP81_tattoo_quickStartGuide' });
                  window.open(
                    'https://doc.labelife.net/upload/documents/TP81_QuickGuideBook.pdf'
                  );
                }
              "
              target="_blank"
              title="Click to learn more"
              >Quick Start Guide</a
            >
            |
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP81_tattoo_manual' });
                  window.open(
                    'https://doc.labelife.net/upload/documents/TP81 Tattoo Stencil Printer Manual.pdf'
                  );
                }
              "
              target="_blank"
              title="Click to learn more"
              >PTP81 Tattoo Stencil Printer Manual</a
            >
          </div>
          <hr
            style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
            v-show="!isMobile()"
          />
          <p>
            Phomemo Tattoo Transfer Paper For TP81, Please click below Link:
          </p>
          <div class="linkDiv" ref="howToVideosRef">
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP81_tattoo_suppliesSales' });
                  window.open('https://www.amazon.com/dp/B0BRKB4KWB');
                }
              "
              target="_blank"
              title="Click to learn more"
              >A4 Tattoo Transfer Paper (8.27"x11.69")</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/videosIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">HOW-TO VIDEOS</div>
      </div>
      <br />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Mac</a>
        </div>
        <div class="centerDiv">
          <p>MacOS 10.14</p>
          <p>MacOS 10.15</p>
          <p>MacOS 10.11</p>
          <p>MacOS 12</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster=""
            style="width: 100%"
            id="TP81_tattoo_macVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/MAC%E7%89%88%E6%9C%AC.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            class="videoLogoImg"
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 0 auto"
          />
          <a class="a-link">For Windows</a>
        </div>
        <div class="centerDiv">
          <p>Windows 7 (32 and 64 bit)</p>
          <p>Windows 8 (32 and 64 bit)</p>
          <p>Windows 10 (32 and 64 bit)</p>
          <p>Windows 11 (64 bit)</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster=""
            style="width: 100%"
            id="TP81_tattoo_windowsVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/Windows%E7%89%88%E6%9C%AC.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />

      <div class="videosDivE">
        <div class="leftDiv" style="padding-top: 3%">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/chrome.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Chrome OS</a>
        </div>
        <div class="centerDiv" style="padding-top: 6%">
          <p>Download Extension For Chrome OS</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="TP81_tattoo_chromeVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/chrome%E7%89%88%E6%9C%AC.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/pm246sLinux.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Linux</a>
        </div>
        <div class="centerDiv" style="padding-top: 5%">
          <p>Download Driver For Linux System</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="TP81_tattoo_linuxVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/linux%E7%89%88%E6%9C%AC.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://pages.phomemo.com/resources/phomemoAppQrCode.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">APP for Smart Phone</a>
        </div>
        <div class="centerDiv" style="padding-top: 3%">
          <p>Phomemo App For IOS Device</p>
          <p>Phomemo App For Android device</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="TP81_tattoo_APPVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/%E6%89%8B%E6%9C%BA%E8%BF%9E%E6%8E%A5.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv" ref="driversRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/driversIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">DRIVERS</div>
      </div>
      <div class="downloadTitleBar">
        <span>TP81 series Driver setup package (Windows)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          @click="
            () => {
              refreshRecord({ key: 'TP81_tattoo_windowsDrivers' });
              window.open(
                'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_WIN_EN.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size">(2.26 MB)</span>
      </div>
      <div class="downloadText">
        <p>
          OPERATING SYSTEM: Windows 7, Windows 8, Windows 10(32 and 64 bit)
          Windows 11(64 bit)
        </p>
      </div>
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />
      <div class="downloadTitleBar">
        <span>TP81 series Driver setup package (Windows ARM)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'TP81_tattoo_ARMDrivers' });
              window.open(
                'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_WIN-ARM_EN.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size" style="top: 31px"
          >(1.31 MB)</span
        >
      </div>
      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>TP81 series Driver setup package (Mac)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          @click="
            () => {
              refreshRecord({ key: 'TP81_tattoo_macDrivers' });
              window.open(
                'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_MAC_EN.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size">(12.0 MB)</span>
      </div>
      <div class="downloadText">
        <p>OPERATING SYSTEM: macOS 10.14, macOS 10.15, macOS 10.11, macOS 12</p>
      </div>
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>TP81 Series Extension setup (Chrome OS)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'TP81_tattoo_chromeDrivers' });
              window.open(
                'https://chrome.google.com/webstore/detail/labelife/fahkjfnppokdemlfodklgmdklmcllidl'
              );
            }
          "
        >
          CLICK HERE
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <!-- <span class="showSizeDiv" title="File Size">(528 KiB)</span> -->
      </div>
      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>TP81 series Driver setup package (Linux)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'TP81_tattoo_linuxDrivers' });
              window.open(
                'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_Linux_EN.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size" style="top: 31px"
          >(351 KB)</span
        >
      </div>
    </div>

    <div class="howToVideosDiv" style="margin-top: 40px" ref="appDownloadRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/driversIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">APP</div>
      </div>
      <div class="appDownloadContainer">
        <div class="everyItemArea">
          <img :src="appDownIcon" style="max-width: 150px" />
          <h3>Phomemo APP - IOS</h3>
          <p>Easily print from your iOS device with the Phomemo App</p>
          <p>
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP81_tattoo_AppStore' });
                  window.open(
                    'https://apps.apple.com/us/app/phomemo/id1456102145'
                  );
                }
              "
              target="_blank"
              title="Click to download"
              >LEARN MORE</a
            >
          </p>
        </div>
        <div class="dividerLineDiv"></div>
        <div class="everyItemArea">
          <img :src="appDownIcon" style="max-width: 150px" />
          <h3>Phomemo APP - Android</h3>
          <p>Easily print from your Android device with the Phomemo App</p>
          <p>
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP81_tattoo_GooglePlay' });
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.quyin.phomemo'
                  );
                }
              "
              target="_blank"
              title="Click to download"
              >LEARN MORE</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv faqBarDiv" ref="faqRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/faqsIcon.png"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div
            class="faq-item"
            v-for="(item, index) in faqDataApp"
            :key="index"
          >
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/delIconImg.png"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/addIconImg.png"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--   联系方式 -->
    <div class="customServiceDiv">
      <div class="everyRow">
        Email：
        <a
          @click="
            () => {
              refreshRecord({ key: 'TP81_tattoo_email' });
              window.open('mailto:support@phomemo.com');
            }
          "
          >support@phomemo.com</a
        >
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">WhatsApp：+86 15338193665</div>
    </div>

    <div class="back-to-top-div">
      <a @click="backTop"><img :src="toTopIcon" /><br />Back to top</a>
    </div>
  </div>
</template>

<script>
const domainApp = "https://doc.labelife.net/upload/video/omezizy/faqImg/app/";
const faqDataApp = [
  {
    title: "1. Are there any other uses for TP81 Tattoo Stencil Printer?",
    details: [
      {
        theme:
          "No, TP81 is a printer specifically designed for tattoo enthusiasts.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "2. After I print out the pattern, how to transfer it onto skin?",
    details: [
      {
        theme:
          "1.Prior to transferring, it is necessary to clean the skin by wiping it with alcohol to eliminate any oils.",
        imgUrls: [],
      },
      {
        theme:
          "2.Gently apply the transfer tattoo paste or deodorant onto the skin.",
        imgUrls: [],
      },
      {
        theme:
          "3.Press the back side of the pattern firmly against the skin for at least 3 seconds before removing the paper.",
        imgUrls: [],
      },
      {
        theme:
          "4.Allow the stenciled skin to dry for a period of 10-15 minutes.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "3. Do I need to replace the ink or ribbon regularly?",
    details: [
      {
        theme:
          "No. TP81 Tattoo Printer with thermal printing technology does not require additional consumables such as ink and ribbon.",
        imgUrls: [],
      },
    ],
  },
  {
    title:
      "4. What is the difference between this printer and Phomemo M08f Tattoo Stencil Printer?",
    details: [
      {
        theme:
          "TP81 tattoo printer is optimized specifically for tattoo printing. We have improved the printer's algorithms for better rendering of clear tattoo patterns. The complimentary paper is also different. TP81 has a dedicated tattoo app interface.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "5. Can't connect my phone with Bluetooth, what should I do?",
    details: [
      {
        theme:
          "1. Please make sure that the Bluetooth on the drop-down page is turned on and then connect the printer in the “Phomemo” APP.",
        imgUrls: [],
      },
      {
        theme:
          "2. Please make sure that all permissions were allowed when installing the app or you can turn them on in the Settings of the phone.",
        imgUrls: [],
      },
      {
        theme: "3. Please try restarting the printer and phone.",
        imgUrls: [],
      },
      {
        theme:
          "4. Please try to reinstall Phomemo App or download Phomemo on another mobile phone to see if it can connect to the printer.",
        imgUrls: [],
      },
      {
        theme:
          "If that still doesn't work, please use thermal paper, double-click to print the QR code, and then scan the QR code in our APP to connect.",
        imgUrls: [],
      },
      {
        theme:
          "If it still does not work, please provide us with the information below to check.",
        imgUrls: [],
      },
      {
        theme: "1. The model and system version of your phone.",
        imgUrls: [],
      },
      {
        theme: "2. The APP version.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "6. The printer has a paper jam, what do I have to do to fix it?",
    details: [
      {
        theme:
          "1. Ensure that the paper is installed correctly. Pull the paper to the correct position and close the paper bin.",
        imgUrls: [],
      },
      {
        theme:
          "2. If the paper is installed correctly, double-click the power button to print out a QR code and check if it prints normally.",
        imgUrls: [],
      },
      {
        theme:
          "3. Make sure the printer has enough power. If it is below 20%, charge it for approximately 2 hours before attempting to print again.",
        imgUrls: [],
      },
      {
        theme:
          "4. Check the print head, rubber roller, and paper outlet for any dirt or debris. Use a 5.cotton swab dipped in alcohol to clean them.",
        imgUrls: [],
      },
      {
        theme:
          "Try using thermal paper instead of tattoo paper to see if it can print normally.",
        imgUrls: [],
      },
      {
        theme:
          "5. Verify the firmware version of your printer. An outdated firmware version may cause paper jams. Please send a screenshot of the firmware version to our customer service, and we will assist you in updating it.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "7. The printout is not clear, what do I have to do?",
    details: [
      {
        theme: "1. Please increase the print density in the APP.",
        imgUrls: [],
      },
      {
        theme:
          "2. Please try to clean the print head. Wipe the cutting part of the printer, especially the black line, with alcohol cotton to ensure no dirt on the print head.",
        imgUrls: [],
      },
      {
        theme:
          "3.Most of the poor printing results are printed with low quality source files. Please try to print the template in the APP and send a photo of the printed template for us to check.",
        imgUrls: [],
      },
      {
        theme:
          "4. Try to replace another roll of paper for printing. It may be damp and affect the printing quality.",
        imgUrls: [],
      },
      {
        theme:
          "5.Please check the battery of the printer, If it is less than 10%, please charge it in time.",
        imgUrls: [],
      },
      {
        theme:
          "If none of the above methods solves the problem, please contact our customer service team.",
        imgUrls: [],
      },
    ],
  },
];
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
import { refreshRecord, sensorsRecord } from "@/util.js";
export default {
  name: "TP81",
  props: {},
  data() {
    return {
      faqDataApp,
      activeQuestion2: {},
      isMobile,
      window,
      appDownIcon: require("@/assets/appDownIcon.jpg"),
      clickName: "",
      toTopIcon: require("@/assets/toTopIcon.png"),
      refreshRecord,
    };
  },
  mounted() {
    this.listenVideo("TP81_tattoo_macVideo");
    this.listenVideo("TP81_tattoo_windowsVideo");
    this.listenVideo("TP81_tattoo_chromeVideo");
    this.listenVideo("TP81_tattoo_linuxVideo");
    this.listenVideo("TP81_tattoo_APPVideo");
    sensorsRecord({ key: "TP81_view" }, 1);
    sensorsRecord({ key: "TP81_WebStay" }, 3);
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({ key: videoId });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        refreshRecord({ key: "TP81_tattoo_FAQ" + (index + 1) });
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
    backTop() {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();
      this.clickName = "";
    },

    turnToItem(refName = "") {
      const ref = this.$refs[refName];
      this.clickName = refName;
      if (ref && ref.scrollIntoView) ref.scrollIntoView();
    },
  },
};
</script>

<style lang="less" src="./m08f_2.less" />



// WEBPACK FOOTER //
// src/view/guides/TP81.vue